import {
  CreateUpdateContactDto,
  CreateUpdateContactDtoFromJSON,
  DefaultApi,
  GetContactDto,
} from '../autogenerated/pokApiClient';
import { GetLastEditorDto } from '../autogenerated/pokApiClient/models/GetLastEditorDto';
import { GridRecord } from '../../components/Grid/GridDataTypes';
import { contactForGrid } from '../../../pok/components/Contacts/ContactSearch';
import { ContactSchema } from '../validation/schemas';
import { validateAgainst } from '../validation/validateAgainst';

export interface ContactContextInterface {
  getById: (id: string) => Promise<GetContactDto>;
  getAllByPortionForClient: (
    pageSize: number,
    pageNumber: number,
    orderBy?: string,
    orderDirection?: string,
    filterText?: string,
    filterColumns?: string,
    clientId?: string,
    lang?: string,
  ) => Promise<GridRecord[]>;
  getAllCountForClient: (
    filterText?: string,
    filterColumns?: string,
    clientId?: string,
  ) => Promise<number>;
  update: (id: string, dto: CreateUpdateContactDto) => Promise<void>;
  create: (dto: CreateUpdateContactDto) => Promise<GetContactDto>;
  getLastEditor: (id: string) => Promise<GetLastEditorDto>;
}

export const ContactContext = (api: DefaultApi) => {
  return {
    getById: (id: string) => api.contactControllerGet(id),
    getAllByPortionForClient: async (
      pageSize: number,
      pageNumber: number,
      orderBy?: string,
      orderDirection?: string,
      filterText?: string,
      filterColumns?: string,
      clientId?: string,
      lang?: string,
    ) => {
      const data = await api.contactControllerGetAllByPortion(
        pageSize,
        pageNumber,
        orderBy || '',
        orderDirection || '',
        filterText || '',
        filterColumns,
        clientId,
      );

      return data.map(item => contactForGrid(item, lang || 'PL'));
    },
    getAllCountForClient: (
      filterText?: string,
      filterColumns?: string,
      clientId?: string,
    ) => {
      return api.contactControllerGetAllCount(
        filterText || '',
        filterColumns,
        clientId,
      );
    },
    update: (id: string, dto: CreateUpdateContactDto) =>
      api.contactControllerUpdate(id, dto),
    create: (dto: CreateUpdateContactDto) => api.contactControllerCreate(dto),
    getLastEditor: (id: string) => api.contactControllerGetLastEditor(id),
  };
};

export const newContact = (clientId?: string) => {
  return CreateUpdateContactDtoFromJSON({ clientId, active: true });
};

export const validate = (contact: CreateUpdateContactDto) =>
  validateAgainst(ContactSchema, contact);

export const convert = (contact?: GetContactDto) => {
  if (!contact) {
    return newContact();
  }

  const converted = CreateUpdateContactDtoFromJSON(contact);
  converted.clientId = contact.client?.id;
  converted.contactTypeId = contact.contactType?.id;
  return converted;
};
